<template>
  <v-container>
    <v-gallery :images="gallery.file" :index="gallery.index" @close="gallery.index = null" />
    <h2 class="mt-5 mb-10">{{$t('summary_report_title')}}</h2>
    <v-card class="px-6 pb-0 mb-3">
      <v-row>
        <v-col md="3" class="pb-0">
          <v-menu ref="menu" v-model="menuStart" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="dateFormatted(startDate)" :label="$t('start_date')" prepend-icon="mdi-calendar"
                readonly v-on="on" color="primary"></v-text-field>
            </template>
            <v-date-picker v-model="startDate" @change="onStartDateChange" no-title scrollable :locale="$t('locale')"
              show-current="false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" class="pb-0">
          <v-menu ref="menu" v-model="menuEnd" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field :value="dateFormatted(endDate)" :label="$t('end_date')" prepend-icon="mdi-calendar" readonly
                v-on="on" color="primary"></v-text-field>
            </template>
            <v-date-picker v-model="endDate" @change="onEndDateChange" no-title scrollable :locale="$t('locale')"
              :show-current="currentDate" :min="startDate" :max="maxDate"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="6" class="pt-6 pb-6">
          <v-btn class="ml-1 mr-1" color="primary" @click="chooseSearch">
            <v-icon>mdi-magnify</v-icon>{{$t('search')}}
          </v-btn>

          <v-btn class="ml-1 mr-1 float-right" outlined color="primary" :disabled="loading"
            @click="openDownloadMonthlyDialog">
            <v-icon>mdi-download</v-icon>{{$t('download_report')}}
          </v-btn>

          <!-- <v-btn
            class="ml-1 mr-1 float-right"
            outlined
            color="primary"
            :disabled="loadingCleansing"
            @click="downloadSummaryReport(false)"
            :loading="loadingDownload"
          >
            <v-icon>mdi-download</v-icon>{{$t('download_report')}}
          </v-btn> -->
          <!-- 
          <v-btn class="ml-1 mr-1 float-right" color="success" @click="newCleansing">
            <v-icon v-bind:class="{ spin: loadingCleansing }">mdi-sync</v-icon>{{$t('sync')}}
          </v-btn> -->
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mt-6">
      <v-col class="pt-0">
        <v-card @click="filterCTA('on_time')" :style="filter === 'on_time' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text">
                <AnimateNumber :number="analyticsSummary.on_time" />
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('on_time')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('in_tolerance')" :style="filter === 'in_tolerance' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 warning--text">
                <AnimateNumber :number="analyticsSummary.tolerance_time" />
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('in_tolerance')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('late')" :style="filter === 'late' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text">
                <AnimateNumber :number="analyticsSummary.late" />
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('late')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('correction')" :style="filter === 'correction' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 edited--text">{{analyticsSummary.correction_time}}
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('correction_time')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('in_location_area')" :style="filter === 'in_location_area' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 success--text">
                <AnimateNumber :number="analyticsSummary.on_location" />
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('in_location')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('tolerance_location')" :style="filter === 'tolerance_location' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 warning--text">{{summary.tolerance_location}}</v-list-item-title>
              <v-list-item-subtitle>{{$t('in_tolerance_location')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('out_location')" :style="filter === 'out_location' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 error--text">{{summary.out_of_location}}</v-list-item-title>
              <v-list-item-subtitle>{{$t('out_of_location')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col class="pt-0">
        <v-card @click="filterCTA('correction_location_area')" :style="filter === 'correction_location_area' ? 'background: #ededed' : ''">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 edited--text">{{analyticsSummary.correction_location}}
              </v-list-item-title>
              <v-list-item-subtitle>{{$t('correction_location')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="5">
        <v-row>
          <v-col class="mt-0 pt-0">
            <v-text-field :label="$t('search_groups')" v-model="searchGroupsByTree"
              :append-icon="showTreeView ? 'mdi-menu-up' : null" @click:append="showTreeView = false"
              @focus="toggleDropdown(true)" :rules="[validator.alfaNumberNotRequired]"></v-text-field>
          </v-col>
          <v-col md="2" v-if="selectedGroups.length > 0">
            <v-chip class="ma-2" color="primary" text-color="white">{{selectedGroups.length}}</v-chip>
          </v-col>
        </v-row>

        <v-card light class="w-100 fix sae-dropdown" v-if="showTreeView" v-click-outside="closeTreeView">
          <v-treeview absolute hoverable :items="groupList" open-all transition :selectable="true"
            :search="searchGroupsByTree" selection-type="independent" v-model="selectedGroups">
            <template v-slot:label="{ item, open, selected }">
              <div style="cursor: pointer" @click="checkSearchValue(item.id)">
                <v-icon v-if="!item.file">{{open ? "mdi-folder-open" : "mdi-folder"}}</v-icon>
                <span>{{ item.name }}</span>
              </div>
            </template>
          </v-treeview>
        </v-card>
      </v-col>
      <v-col md="3" class="mt-0 pt-0">
        <v-select v-model="selectedScheduleType" :items="shiftList" item-text="name" item-value="id"
          :label="$t('schedule_type')" @change="filterAttendanceByScheduleType($event)"></v-select>
      </v-col>
      <v-col md="4" class="mt-0 pt-0">
        <v-autocomplete clearable v-model="userId" :label="$t('search_user') + '...'" prepend-inner-icon="mdi-magnify"
          @change="calculateFilteredSummary($event)" @click:clear="calculateFilteredSummary(null)" single-line
          hide-details :items="userList" hide-no-data hide-selected item-value="id" item-text="full_name" return-object
          :loading="findUserButton"></v-autocomplete>

      </v-col>
    </v-row>

    <v-card>
      <v-data-table :loading="loading" :loading-text="$t('loading_summary')" :headers="headers" :items="attendances"
        :search="search" :sort-by="['date', 'full_name']" :server-items-length="totalData" :items-per-page="itemPerPage"
        :footer-props="{ 
        'items-per-page-options': [10, 50, 100],
        'items-per-page-text': $t('rows_per_page') }" :page="page" @update:page="paginatePage($event, itemPerPage)"
        @update:items-per-page="paginatePage(page, $event)" :sort-desc="[true, false]" :group-desc="true"
        group-by="date" multi-sort :no-data-text="$t('no_data')">
        <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
          {{ items.itemsLength }} </template>
        <template v-slot:group.header="{ items }">
          <th colspan="100%">
            <span class="center subtitle-1">
              <b class="f-13">{{$t('date')}} {{ items[0].date }}</b>
            </span>
          </th>
        </template>
        <template v-slot:item.note_in="{ item }">
          <div v-if="item.note_in">
            <v-chip :color="getNoteColor(item.note_in)" class="caption">{{checkStatusTime(item.status, item.note_in)}}
            </v-chip>
          </div>
          <div v-else>-</div>
        </template>
        <template v-slot:item.note_out="{ item }">
          <v-chip :color="getNoteColor(item.note_out)" class="caption">{{checkStatusTime(item.status, item.note_out)}}
          </v-chip>
        </template>
        <template v-slot:item.reason_in="{ item }">
          <v-chip :color="getReasonColor(item.reason_in)" class="caption" v-if="checkReason(item.reason_in)">
            {{ translateMe(item.reason_in) }}</v-chip>
          <div v-else>-</div>
        </template>
        <template v-slot:item.reason_out="{ item }">
          <v-chip :color="getReasonColor(item.reason_out)" class="caption" v-if="checkReason(item.reason_out)">
            {{ translateMe(item.reason_out) }}</v-chip>
          <div v-else>-</div>
        </template>
        <template v-slot:item.status="{ item }">
          <span v-if="item.status == 'absent'">{{$t('absent')}}</span>
          <span v-if="item.status == 'checkoutbysystem'">{{$t('checkoutbysystem')}}</span>
          <span v-if="item.status == 'leave'">{{$t('leave')}}</span>
          <span v-if="item.status == 'checkout'">{{$t('present')}}</span>
          <span v-if="item.status == 'national holiday'">{{$t('national_holiday')}}</span>
          <span v-if="item.status == 'corporate holiday'">{{$t('corporate_holiday')}}</span>
          <span v-if="item.status == 'corrected'">{{$t('corrected')}}</span>
          <span v-if="item.status == 'checkin'">{{$t('checkin')}}</span>
          <span v-if="item.status == 'edited'">{{$t('edited')}}</span>
          <span v-if="item.status == 'dayoff'">{{$t('dayoff')}}</span>
          <span v-if="item.status == 'holiday'">{{$t('holiday')}}</span>
          <span v-if="item.status == 'overtime'">{{$t('present')}}</span>
          <span v-if="item.status == 'others'">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <b v-bind="attrs" v-on="on" class="cursor text-primary">{{$t('others')}}</b>
              </template>
              <span>{{item.schedule_description}}</span>
            </v-tooltip>
          </span>
        </template>
        <!-- Table Edit & Delete Buttons -->
        <template v-slot:item.details="{ item }">
          <v-icon medium class="mr-2" color="primary" @click="openDetailsDialog(item)">mdi-card-account-details-outline
          </v-icon>
        </template>
        <template v-slot:top>
          <v-dialog v-model="detailsDialog" max-width="1200px">
            <v-card class="pt-3" v-if="loadingDetails">
              <v-container>
                <v-row>
                  <v-col md="6">
                    <v-card-title>
                      <v-icon medium class="mr-2" color="primary">mdi-account</v-icon>
                      {{ userDetail.full_name }}
                    </v-card-title>
                    <v-card-text class="pb-0">
                      <v-icon medium class="mr-2" color="primary">mdi-email</v-icon>
                      {{ userDetail.email }}
                    </v-card-text>
                    <v-card-text>
                      <v-icon medium class="mr-2" color="primary">mdi-barcode</v-icon>
                      {{ userDetail.employeecode }}
                    </v-card-text>
                  </v-col>
                  <v-col md="6">
                    <v-card-text class="pb-0">
                      <v-icon medium class="mr-2" color="primary">mdi-calendar-range</v-icon>
                      {{ userDetail.date }}
                    </v-card-text>
                    <v-card-text class="pb-0">
                      <v-icon medium class="mr-2" color="primary">mdi-sitemap</v-icon>
                      {{ userDetail.group_name }} ({{userDetail.shifting ? $t('shifting') : $t('regular')}})
                    </v-card-text>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col md="3" class="pt-0">
                    <v-card>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1 primary--text">{{ userDetail.workhour }}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{$t('workhour')}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                  <v-col md="3" class="pt-0">
                    <v-card>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1 red--text">{{ userDetail.late_time }}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{$t('late_time')}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                  <v-col md="3" class="pt-0">
                    <v-card>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1 success--text">
                            {{ userDetail.overtime == 'Invalid date' ? '00:00:00' : userDetail.overtime }}
                          </v-list-item-title>
                          <v-list-item-subtitle>{{$t('overtime')}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                  <v-col md="3" class="pt-0">
                    <v-card>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1 primary--text capitalize">
                            <span v-if="userDetail.status == 'absent'">{{$t('absent')}}</span>
                            <span v-if="userDetail.status == 'checkoutbysystem'">{{$t('checkoutbysystem')}}</span>
                            <span v-if="userDetail.status == 'leave'">{{$t('leave')}}</span>
                            <span v-if="userDetail.status == 'checkout'">{{$t('present')}}</span>
                            <span v-if="userDetail.status == 'national holiday'">{{$t('national_holiday')}}</span>
                            <span v-if="userDetail.status == 'corporate holiday'">{{$t('corporate_holiday')}}</span>
                            <span v-if="userDetail.status == 'corrected'">{{$t('corrected')}}</span>
                            <span v-if="userDetail.status == 'checkin'">{{$t('checkin')}}</span>
                            <span v-if="userDetail.status == 'edited'">{{$t('edited')}}</span>
                            <span v-if="userDetail.status == 'dayoff'">{{$t('dayoff')}}</span>
                            <span v-if="userDetail.status == 'holiday'">{{$t('holiday')}}</span>
                            <span v-if="userDetail.status == 'overtime'">{{$t('present')}}</span>
                            <span v-if="userDetail.status == 'others'">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <b v-bind="attrs" v-on="on" class="cursor text-primary">{{$t('others')}}</b>
                                </template>
                                <span>{{userDetail.schedule_description}}</span>
                              </v-tooltip>
                            </span>
                          </v-list-item-title>
                          <v-list-item-subtitle>Status</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                </v-row>
                <v-divider class="my-6"></v-divider>
                <v-card-text>
                  <div v-if="userDetail">
                    <v-row>
                      <v-col md="6">
                        <GmapMap :center="{
                            lat: userDetail.lat_in ? userDetail.lat_in : -6.1753871,
                            lng: userDetail.lng_in ? userDetail.lng_in : 106.8249641,
                          }" :zoom="12" map-type-id="terrain" style="width: 500px; height: 300px">
                          <GmapCluster>
                            <GmapMarker :position="{
                                lat: userDetail.lat_in ? userDetail.lat_in  : -6.1753871,
                                lng: userDetail.lng_in ? userDetail.lng_in  : 106.8249641,
                              }" :clickable="true" @click="toggleInfo(userDetail)" />
                            <GmapMarker :position="{
                                lat: userDetail.lat_out ? userDetail.lat_out : -6.1753871,
                                lng: userDetail.lng_out ? userDetail.lng_out : 106.8249641,
                              }" :clickable="true" @click="toggleInfoOut(userDetail)" />
                          </GmapCluster>
                          <GmapInfoWindow :options="info_options" :position="info_position" :opened="info_opened"
                            @closeclick="info_opened = false">{{ info_content }}</GmapInfoWindow>
                        </GmapMap>
                      </v-col>
                      <v-col md="6">
                        <v-row>
                          <v-col md="6">
                            <p>
                              {{$t('time_in')}} :
                              {{
                              toHours(
                              userDetail.timezone_in,
                              userDetail.time_in
                              )
                              }}
                              <span>{{checkTimeZone(userDetail.timezone_in)}}</span>
                            </p>
                            <p>{{$t('reason_in')}} : {{ userDetail.reason_in ? userDetail.reason_in : '-' }}</p>
                            <p>{{$t('reason_user_in')}} :
                              {{ userDetail.reason_user_in ? userDetail.reason_user_in : '-' }}</p>
                            <p>{{$t('note_in')}} : {{ userDetail.note_in ? userDetail.note_in : '-' }}</p>
                            <p>{{$t('note_user_in')}} : {{ userDetail.note_user_in ? userDetail.note_user_in : '-' }}
                            </p>
                            <div v-if="feature_temperature_enabled">
                              <p>
                                {{$t('temperature_in')}}:
                                <v-chip dark :color="getColorByTemp(userDetail.temperature_in)">
                                  {{ userDetail.temperature_in ? `${userDetail.temperature_in} ºC` : '-' }}</v-chip>
                              </p>
                              <p>
                                {{$t('temperature_att_in')}}:
                                <span
                                  v-if="userDetail.temperature_attachment_in != '' && userDetail.temperature_attachment_in != '-' && userDetail.temperature_attachment_in != null">
                                  <v-btn icon @click="openGallery(userDetail.temperature_attachment_in)">
                                    <v-icon>mdi-file</v-icon>
                                  </v-btn>
                                </span>
                                <span v-else>-</span>
                              </p>
                            </div>
                          </v-col>
                          <v-col md="6">
                            <p>{{$t('time_out')}} :
                              {{ toHours(userDetail.timezone_out ? userDetail.timezone_out : userDetail.timezone_in , userDetail.time_out) }}
                              <span>{{checkTimeZone(userDetail.timezone_out)}}</span></p>
                            <p>{{$t('reason_out')}} : {{ userDetail.reason_out ? userDetail.reason_out : '-'}}</p>
                            <p>{{$t('reason_user_out')}} :
                              {{ userDetail.reason_user_out ? userDetail.reason_user_out : '-' }}</p>
                            <p>{{$t('note_out')}} : {{ userDetail.note_out ? userDetail.note_out : '-' }}</p>
                            <p>{{$t('note_user_out')}} : {{ userDetail.note_user_out ? userDetail.note_user_out : '-' }}
                            </p>
                            <div v-if="feature_temperature_enabled">
                              <p>{{$t('temperature_out')}}:
                                <v-chip dark :color="getColorByTemp(userDetail.temperature_out)">
                                  {{userDetail.temperature_out ? `${userDetail.temperature_out} ºC` : '-'}}</v-chip>
                              </p>
                              <p>
                                {{$t('temperature_att_out')}}:
                                <span
                                  v-if="userDetail.temperature_attachment_out != '' && userDetail.temperature_attachment_out != '-' && userDetail.temperature_attachment_out != null">
                                  <v-btn icon @click="openGallery(userDetail.temperature_attachment_out)">
                                    <v-icon>mdi-file</v-icon>
                                  </v-btn>
                                </span>
                                <span v-else>-</span>
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>
              </v-container>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.time_in="{ item }">
          <div v-if="checkStatusIn(item.status, item.note_in)">{{ toHours(item.timezone_in, item.time_in) }}
            <span>{{checkTimeZone(item.timezone_in)}}</span></div>
          <div v-else>-</div>
        </template>
        <template v-slot:item.time_out="{ item }">
          <div v-if="checkStatusOut(item.status)">
            {{ toHours(item.timezone_out ? item.timezone_out : item.timezone_in, item.time_out) }}
            <span>{{checkTimeZone(item.timezone_out)}}</span></div>
          <div v-else>-</div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog Download Monthly -->
    <v-dialog v-model="downloadMonthlyDialog"  :max-width="lang === 'id' ? '900px' : '720px'">
      <v-form v-model="valid" ref="downloadForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2 mb-4">{{$t('download_report')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container class="px-6">
              <v-row align-content="center" align="center" justify="center">
                <v-col cols="12" class="pa-1">
                  <v-row align="center" justify="center">
                    <v-col md="4" style="position: relative;" class="pa-1 mx-0" :class="lang === 'id' ? 'set-radio2' : 'set-radio1'">
                      <v-radio-group v-model="radioSetTime">
                        <v-row class="pa-1 mx-0">
                          <v-col class="pa-0 mx-0">
                            <v-radio :value="1" :label="$t('by_date')"></v-radio>
                          </v-col>
                          <v-col class="pa-0 mx-0">
                            <v-radio :value="2" :label="$t('by_month')"></v-radio>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </v-col>
                    <v-col v-if="radioSetTime === 2" md="4" class="pa-0 pl-8 pr-4">
                      <v-select v-model="downloadMonthlyData.month" @change="checkCutOff()" :items="monthList" color="white" hide-no-data
                        hide-selected item-text="name" item-value="id" :label="$t('select_month')" :rules="rules">
                      </v-select>
                    </v-col>
                    <v-col v-if="radioSetTime === 2" md="4" class="pa-0 pl-6 pr-4">
                      <v-select v-model="downloadMonthlyData.year"  @change="checkCutOff()" :items="yearList" color="white" hide-no-data
                        hide-selected :label="$t('select_year')" :rules="rules"></v-select>
                    </v-col>
                    <v-col v-if="radioSetTime === 1" md="4" class="pa-0 pl-8 pr-4">
                      <v-menu ref="menu" v-model="menuStart2" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field :value="dateFormatted(startDate2)" :label="$t('start_date')"
                            prepend-icon="mdi-calendar" readonly v-on="on" color="primary"></v-text-field>
                        </template>
                        <v-date-picker v-model="startDate2" @change="onStartDateChange2" no-title scrollable
                          :locale="$t('locale')" show-current="false"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col v-if="radioSetTime === 1" md="4" class="pa-0 pl-8 pr-4">
                      <v-menu ref="menu" v-model="menuEnd2" :close-on-content-click="false"
                        transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                          <v-text-field :value="dateFormatted(endDate2)" :label="$t('end_date')"
                            prepend-icon="mdi-calendar" readonly v-on="on" color="primary"></v-text-field>
                        </template>
                        <v-date-picker v-model="endDate2" @change="onEndDateChange2" no-title scrollable
                          :locale="$t('locale')" :show-current="currentDate2" :min="startDate2" :max="maxDate2">
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="12" class="pa-1">
                  <v-autocomplete v-model="downloadMonthlyData.groupId" @change="getUserListByGroupId(downloadMonthlyData.groupId)" :items="groupListDownload" color="#828282"
                    hide-no-data hide-selected item-text="name" item-value="id" :label="$t('select_group')" required
                    ></v-autocomplete>
                </v-col>
                <v-col md="12" class="pa-1">
                  <v-autocomplete v-model="userId2" :loading="loadingUser" :disabled="loadingUser" :items="filteredUser" color="#828282" hide-no-data
                    hide-selected item-text="fullname" item-value="id" :label="$t('select_user')" required
                    ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-container class="text-center">
              <v-row class="mx-auto mt-n6" align="center" align-content="center">
                <v-col cols="3">
                </v-col>
                <v-col>
                  <v-btn @click="closeDownloadDialog()">Cancel</v-btn>
                </v-col>
                <v-col>
                  <v-btn color="primary" @click="downloadSummaryReport()" :disabled="!valid || checkCut">Download</v-btn>
                </v-col>
                <v-col cols="3">
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
  import axios from "axios";
  import moment from "moment";
  import mt from "moment-timezone";
  import _ from 'lodash'

  import AnimateNumber from './components/AnimateNumber'

  export default {
    name: "summaryCombined",
    data() {
       const lang = localStorage.getItem('lang') || 'id';
      return {
         lang: lang,
        analytics: null,
        destroyer: null,
        radioSetTime: 1,
        checkCut: false,
        loadingUser: false,
        counter: 0,
        findUserButton: false,
        selectType: null,
        selectedScheduleType: null,
        shiftList: [{
            id: null,
            name: this.$i18n.t('all')
          },
          {
            id: 0,
            name: this.$i18n.t('regular')
          },
          {
            id: 1,
            name: this.$i18n.t('shift')
          },
        ],
        loadingDownload: false,
        valid: false,
        rules: [(value) => !!value || this.$i18n.t('required')],
        validator: this.$store.state.validator,
        disableChooseGroupDownloadMonthly: false,
        downloadMonthlyDialog: false,
        minDate: '',
        maxDate: '',
        maxDate2: '',
        allowedDate: [],
        currentDate: '',
        currentDate2: '',
        stillRunning: false,
        selectedUser: {},
        supervisorGroup: [],
        tempUserList: [],
        userList: [],
        searchGroupsByTree: '',
        loadingTreeView: false,
        showTreeView: false,
        overlay: false,
        selectedGroups: [],
        gallery: {
          file: [''],
          index: null
        },
        baseUrl: this.$store.state.baseUrl,
        reportUrl: this.$store.state.reportUrl,
        holidayList: [],
        date: new Date().toISOString().substr(0, 10),
        menuStart: false,
        menuEnd: false,
        menuStart2: false,
        menuEnd2: false,
        filteredUser: [],
        searchRaw: '',
        search: '',
        totalData: 0,
        page: 1,
        itemPerPage: 10,
        headers: [{
            text: this.$i18n.t('date'),
            value: "date",
            width: "10%"
          },
          {
            text: this.$i18n.t('employee_name'),
            value: "full_name",
            width: "20%",
            sortable: false
          },
          {
            text: this.$i18n.t('time_in'),
            value: "time_in",
            sortable: false
          },
          {
            text: this.$i18n.t('status_in'),
            value: "reason_in",
            sortable: false
          },
          {
            text: this.$i18n.t('location_in'),
            value: "note_in",
            sortable: false
          },
          {
            text: this.$i18n.t('time_out'),
            value: "time_out",
            sortable: false
          },
          {
            text: this.$i18n.t('status_out'),
            value: "reason_out",
            sortable: false
          },
          {
            text: this.$i18n.t('status'),
            value: "status",
            width: "10%",
            sortable: false
          },
          {
            text: this.$i18n.t('workhour'),
            value: "workhour",
            sortable: false
          },
          {
            text: this.$i18n.t('action'),
            value: "details",
            sortable: false
          },
        ],
        filter: null,
        companyId: this.$store.state.company,
        groupId: this.$store.state.group_id,
        cutOffDate: this.$store.state.cutoff_date,
        startDate: '',
        endDate: '',
        startDate2: '',
        endDate2: '',
        partial: false,
        loading: true,
        attendances: [],
        tempAttendances: [],
        dialog: false,
        detailsDialog: false,
        userDetail: [],
        loadingDetails: true,
        markers: [],
        userId: null,
        userId2: null,
        analyticsSummary: {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
          correction_location: 0,
          correction_time: 0
        },
        summary: {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
        },
        info_options: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        info_position: null,
        info_opened: false,
        info_content: null,
        groupList: [],
        groupListDownload: [],
        searchGroups: '',
        role: null,
        feature_temperature_enabled: false,
        scheduleShift: true,
        downloadMonthlyData: {
          companyId: this.$store.state.company,
          groupId: null,
          month: null,
          year: null,
        },
        monthList: [{
            id: 1,
            name: 'Januari'
          },
          {
            id: 2,
            name: 'Februari'
          },
          {
            id: 3,
            name: 'Maret'
          },
          {
            id: 4,
            name: 'April'
          },
          {
            id: 5,
            name: 'Mei'
          },
          {
            id: 6,
            name: 'Juni'
          },
          {
            id: 7,
            name: 'Juli'
          },
          {
            id: 8,
            name: 'Agustus'
          },
          {
            id: 9,
            name: 'September'
          },
          {
            id: 10,
            name: 'Oktober'
          },
          {
            id: 11,
            name: 'November'
          },
          {
            id: 12,
            name: 'Desember'
          },
        ],
        yearList: [],
        loadingCleansing: false
      };
    },
    methods: {
      async filterCTA(filter){
        if(this.filter != filter){
          this.filter = filter
        }else{
          this.filter = null
        }
      this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
        .searchGroups, this.selectType, this.itemPerPage, this.page, this.partial, this.userId)
      this.attendances = [].concat(this.tempAttendances)
      },
      checkCutOff(){
        const day = moment().format('D')
        const month = moment().format('M')
        const year = parseInt(moment().format('YYYY'))
        const forMoment = moment(day + "-" + month + "-" + year, 'D/M/YYYY').valueOf()
         const forCutOff = moment(this.cutOffDate + "-" + this.downloadMonthlyData.month + "-" + this.downloadMonthlyData.year, 'D/M/YYYY').valueOf()
          
        if(forMoment <= forCutOff){
          this.checkCut = true
        }else{
          this.checkCut = false
        }

      },
      async filterAttendanceByScheduleType(type) {
        this.page = 1;
        this.selectedScheduleType = type;
        if (type == 0) {
          this.partial = true;
          this.selectType = null;
        } else if (type == 1) {
          this.partial = true;
          this.selectType = true;
        } else {
          this.partial = false;
          this.selectType = null;
        }
        this.resetSummary();
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
          .searchGroups, this.selectType, this.itemPerPage, this.page, this.partial, this.userId)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      toggleDropdown(bool) {
        if (bool) {
          this.counter = 0
          this.showTreeView = bool
        } else {
          if (this.counter > 0) {
            setTimeout(() => {
              this.showTreeView = bool
            }, 200);
          } else {
            this.counter++
          }
        }
      },
      generateYearList() {
        const createdAt = this.$store.getters.companyDetail.createdAt
        const todayYear = moment(createdAt).set({
          'year': new Date().getFullYear()
        })
        const data = moment(todayYear).diff(createdAt, 'year')
        const result = []
        for (let i = 0; i <= data; i++) {
          result.push(moment(todayYear).subtract(i, 'year').format('YYYY'))
        }
        return result
      },
      openDownloadMonthlyDialog() {
        this.downloadMonthlyDialog = true
      },
      closeDownloadDialog() {
        this.userId2 = null
        this.downloadMonthlyData.groupId = null
        this.downloadMonthlyDialog = false
      },
      getLimitDate(date) {
        this.minDate = moment(date).subtract(99, 'days').format('YYYY-MM-DD')
        this.maxDate = moment(date).add(99, 'days').format('YYYY-MM-DD')
        
      },
       getLimitDate2(date) {
        this.minDate2 = moment(date).subtract(365, 'days').format('YYYY-MM-DD')
        this.maxDate2 = moment(date).add(365, 'days').format('YYYY-MM-DD')
      },
      checkLimitDate() {
        const start = moment(this.startDate)
        const end = moment(this.endDate)
        const diff = start.diff(end, 'days')
        if (diff < 100 && diff > -100) {
          return false
        } else {
          this.showMessage('warning', 'Max 100 days only')
          return true
        }
      },
      checkLimitDate2() {
        const start = moment(this.startDate2)
        const end = moment(this.endDate2)
        const diff = start.diff(end, 'days')
        if (diff < 32 && diff > -32) {
          return false
        } else {
          this.showMessage('warning', 'Max 1 month only')
          return true
        }
      },
      checkStillRunning() {
        setTimeout(() => {
          this.stillRunning = false
        }, 100)
      },
      checkStatusTime(key, note) {
        const lowerKey = (key !== undefined && key !== null) ? key.toLowerCase() : key;
        if ((lowerKey == 'absent') && (note == '' || note == '-' || note == null)) {
          return false
        } else if (lowerKey == 'day-off' || lowerKey == 'dayoff' || lowerKey == null) {
          return this.$i18n.t('dayoff')
        } else {
          return this.$i18n.t(note.toLowerCase())
        }
      },
      checkStatusIn(key, note) {
        const lowerKey = (key !== undefined && key !== null) ? key.toLowerCase() : key;
        if ((lowerKey == 'absent') && (note === '' || note === '-' || note === null)) {
          return false
        } else if (lowerKey == 'day-off' || lowerKey == 'dayoff' || lowerKey == null) {
          return false
        } else {
          return true
        }
      },
      checkStatusOut(key) {
        switch (key !== undefined && key !== null ? key.toLowerCase() : '') {
          // case 'checkoutbysystem':
          case 'checkin':
          case 'absent':
          case 'day-off':
          case 'dayoff':
          case '':
            return false
          default:
            return true
        }
      },
      checkReason(key) {
        switch (key) {
          case null:
          case '-':
          case '':
            return false
          default:
            return true
        }
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },

      checkSearchValue(groupId) {
        const isExist = this.selectedGroups.indexOf(groupId)
        if (isExist > -1) {
          this.selectedGroups.splice(isExist, 1)
        } else {
          this.selectedGroups.push(groupId)
        }
      },
      getDownloadName() {
        const companyName = this.$store.state.companyName
        const date = moment().format('DDMMYYYYhhMM')
        return `Report ${companyName} - ${date}.xls`
      },
      getColorByTemp(temp) {
        switch (true) {
          case (temp > 0 && temp <= 37.5):
            return 'green'

          case (temp > 37.5 && temp <= 39.5):
            return 'orange'
          case (temp > 39.5):
            return 'red'
          default:
            return 'grey'
        }
      },
      openGallery(url) {
        this.gallery.file = [url]
        this.gallery.index = 0
      },
      getGlobalConfig() {
        this.feature_temperature_enabled = this.$store.getters.gcGetData('feature_health_check', 'is_enabled') ? true :
          false
      },
      close() {
        this.dialog = false;
      },
      openDetailsDialog(item) {
        this.showTreeView = false
        this.loadingDetails = true;
        this.userDetail = item;
        const data = this.userList.find(user => {
          if (user.id == item.userId) return user
        })
        if (data) this.userDetail.shifting = data.is_shifted
        this.detailsDialog = true;
      },
      stringToLatLng(lat, lng) {
        let coordinates = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        };
        return coordinates;
      },
      toggleInfo(index, key) {
        this.info_position = this.stringToLatLng(index.lat_in, index.lng_in);
        this.info_content =
          this.toHours(index.timezone_in, index.time_in) + " " + index.full_name;
        if (this.info_current_key == key) {
          this.info_opened = !this.info_opened;
        } else {
          this.info_opened = true;
          this.info_current_key = key;
        }
      },
      toggleInfoOut(index, key) {
        this.info_position = this.stringToLatLng(index.lat_out, index.lng_out);
        this.info_content =
          this.toHours(index.timezone_out, index.time_out) + " " + index.full_name;
        if (this.info_current_key == key) {
          this.info_opened = !this.info_opened;
        } else {
          this.info_opened = true;
          this.info_current_key = key;
        }
      },
      onStartDateChange() {
        this.menuStart = false;
        this.currentDate = this.startDate
        const diff = moment(this.endDate).diff(this.startDate, 'days')
        if (diff < 0) this.endDate = this.startDate
        this.getLimitDate(this.startDate)
      },
      onEndDateChange() {
        this.menuEnd = false;
      },
      onStartDateChange2() {
        this.menuStart2 = false;
        this.currentDate2 = this.startDate2
        const diff = moment(this.endDate2).diff(this.startDate2, 'days')
        if (diff < 0) this.endDate2 = this.startDate2
        this.getLimitDate2(this.startDate2)
        //  if (this.checkLimitDate2()){
        //   this.valid = false
        //  } else{
        //   this.valid = true
        //  }
      },
      onEndDateChange2() {
        this.menuEnd2 = false;
        // if (this.checkLimitDate2()){
        //   this.valid = false
        //  } else{
        //   this.valid = true
        //  }
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      },
      milisToHour(milis) {
        return moment(milis, "x").format("HH:mm");
      },
      countTimeSummary(reason) {
        if (reason === "-" || reason === null) {
          return;
        }
        if (reason === "On-Time") {
          this.summary.on_time += 1;
        } else {
          if (reason === "In-Tolerance") {
            this.summary.tolerance_time += 1;
          } else {
            this.summary.late += 1;
          }
        }
      },
      countLocationSummary(note) {
        if (note === "-" || note === null) {
          return;
        }
        if (note === "In-Area") {
          this.summary.on_location += 1;
        } else {
          if (note === "Meeting" || note === "Work From Home") {
            this.summary.tolerance_location += 1;
          } else {
            this.summary.out_of_location += 1;
          }
        }
      },
      getReasonColor(reason) {
        if (reason === "-" || reason === null || reason === 'Day Off') {
          return;
        }
        if (reason === "On-Time" || reason === "OnTime") {
          return "success";
        } else {
          if (reason === "In-Tolerance") {
            return "warning";
          } else if (reason === "Edited") {
            return "primary"
          } else {
            return "error";
          }
        }
      },
      getNoteColor(note) {
        if (note === "-" || note === null || note === 'Day Off') {
          return;
        }
        if (note === "In-Area") {
          return "success";
        } else {
          if (note === "Meeting" || note === "Work From Home") {
            return "warning";
          } else {
            return "error";
          }
        }
      },
      resetSummary() {
        this.summary = {
          on_time: 0,
          tolerance_time: 0,
          late: 0,
          on_location: 0,
          tolerance_location: 0,
          out_of_location: 0,
        };
      },
      convertDate(time) {
        let convert = time.toString().split(" ");
        let hour = convert[4];
        if (hour) {
          return hour
        } else {
          return '-'
        }
      },
      toHours(zone, time) {
        if (time != undefined) {
          let utc = new Date(parseInt(time));
          let tmp = "";
          if (zone === 7) {
            tmp = mt.tz(utc, "Asia/Jakarta");
          } else if (zone === 8) {
            tmp = mt.tz(utc, "Asia/Makassar");
          } else if (zone === 9) {
            tmp = mt.tz(utc, "Asia/Jayapura");
          }
          return this.convertDate(tmp);
        }
      },
      checkTimeZone(zone) {
        if (zone === 7) {
          return 'WIB'
        } else if (zone === 8) {
          return 'WITA'
        } else if (zone === 9) {
          return 'WIT'
        }
      },
      milisToTime(milis) {
        return moment(milis, "x").format("HH:mm:ss");
      },
      milisToDate(milis) {
        return moment(milis, "x").format("DD-MM-YYYY");
      },

      async downloadSummaryReportMonthly() {
        let params = {
          companyId: this.downloadMonthlyData.companyId,
          month: this.downloadMonthlyData.month,
          year: this.downloadMonthlyData.year,
        }
        if (this.downloadMonthlyData.groupId) params.groupId = this.downloadMonthlyData.groupId
        await this.$store.dispatch('getReportDownloadSummary', params)
      },
      async newCleansing() {
        if (!this.loadingCleansing) {
          this.loadingCleansing = true
          const startDate = moment(this.startDate).format("DD-MM-YYYY");
          const endDate = moment(this.endDate).format("DD-MM-YYYY");
          const params = {
            companyId: this.companyId,
            startDate: startDate,
            endDate: endDate,
          }
          const result = await this.$store.dispatch('getReportNewCleansingShifting', params)
          this.loadingCleansing = false
          if (result) {
            this.showMessage('success', 'Data Synchronized')
            this.chooseSearch()
          }
        }
      },
      async downloadSummaryReport() {
        
        this.loadingDownload = true
        const startDate = moment(this.startDate2).format("DD-MM-YYYY");
        const endDate = moment(this.endDate2).format("DD-MM-YYYY");
        const newStartDate = '01-'+ this.downloadMonthlyData.month +'-'+ this.downloadMonthlyData.year
        const endofMonth = moment(this.downloadMonthlyData.month +'-'+ this.downloadMonthlyData.year, "MM-YYYY").daysInMonth()
        const newEndDate = endofMonth.toString() +'-'+ this.downloadMonthlyData.month +'-'+ this.downloadMonthlyData.year
        const startDateMonthly = moment(newStartDate, "DD-MM-YYYY").format("DD-MM-YYYY");
        const endDateMonthly = moment(newEndDate, "DD-MM-YYYY").format("DD-MM-YYYY");
        let url = `companyId=${this.companyId}`
        if (this.downloadMonthlyData.groupId) url = `${url}&groupId=${this.downloadMonthlyData.groupId}`;
        if (this.userId2) url = `${url}&userId=${this.userId2}`;
        if(this.radioSetTime === 1) url = `${url}&startDate=${startDate}&endDate=${endDate}`;
        if (this.radioSetTime === 2) url = `${url}&startDate=${startDateMonthly}&endDate=${endDateMonthly}`;
        url = `${url}&language=${this.lang}`;
          if(this.radioSetTime === 1 || this.userId2 && this.radioSetTime === 2 ){
        this.$store.dispatch('getReportDownloadSummaryWeekly', url, this.radioSetTime)
          }else{
             this.$store.dispatch('getReportDownloadSummaryWeekly', url)
          }
        this.loadingDownload = false
      },
      async chooseSearch() {
        this.page = 1;
        this.itemPerPage = 10;
        this.partial = false;
        this.selectedScheduleType = null;
        let groupParam = ''
        this.selectedGroups.map((item, i) => {
          groupParam = groupParam + item
          if (i != this.selectedGroups.length - 1) {
            groupParam = groupParam + ','
          }
        })
        if (groupParam == '') {
          if (this.role == 3 || this.role == 4) {
            this.searchGroups = this.groupId
          } else {
            this.searchGroups = groupParam
          }
        } else {
          this.searchGroups = groupParam
        }
        if (this.checkLimitDate()) return;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
          .searchGroups, this.selectType, this.itemPerPage, this.page, this.partial, this.userId)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      async getCalendarHoliday() {
        const result = await this.$store.dispatch('getHolidayByCompany', {
          companyId: this.companyId
        })
        this.holidayList = result
        this.calculateHolidayWithSummary(this.attendances)
      },
      calculateHolidayWithSummary(attendance) {
        attendance.map((item) => {
          const attendanceUser = moment(item.date, 'DD-MM-YYYY')
          this.holidayList.map((hole) => {
            const start = moment(hole.date_start, 'YYYY-MM-DD')
            const end = moment(hole.date_end, 'YYYY-MM-DD')

            const test = moment(attendanceUser).isBetween(start, end, undefined, [])
            if (test) {
              if (item.status == "absent") item.status = hole.category == 1 ? "Corporate Holiday" :
                "National Holiday";
              if (item.note_in == null) item.note_in = "Day Off";
              if (item.note_out == null) item.note_out = "Day Off";
              if (item.reason_in == null) item.reason_in = "Day Off";
              if (item.reason_out == null) item.reason_out = "Day Off";
              if (item.status == "corrected") item.status = "Corrected";
              if (item.status == "checkin") item.status = "Check In";
              if (item.status == "edited") item.status = "Edited";
            }
          })
        })
      },
      costumHeader(action, actionId) {
        return {
          headers: {
            action,
            actionId
          }
        }
      },
      formatDateForParams(date) {
        return moment(date).format("DD-MM-YYYY")
      },
      async getDataAttendanceAdmin(companyId, startDate, endDate, groupId, shifted, totalPageSend, start, isPartial,
        userId) {
        const params = {
          companyId: companyId,
          startDate: this.formatDateForParams(startDate),
          endDate: this.formatDateForParams(endDate),
          page: start,
          pageSize: totalPageSend,
          isPartial: isPartial,
        }
        if(this.filter === 'on_time') params.on_time = true
        if(this.filter === 'in_tolerance') params.in_tolerance = true
        if(this.filter === 'late') params.late = true
        if(this.filter === 'correction') params.correction = true
        if(this.filter === 'in_location_area') params.in_location_area = true
        if(this.filter === 'tolerance_location') params.tolerance_location = true
        if(this.filter === 'out_location') params.out_location = true
        if(this.filter === 'correction_location_area') params.correction_location_area = true
        if (groupId) params.groupId = groupId
        if (shifted) params.scheduleShift = shifted
        if (userId) params.userId = userId
        const result = await this.$store.dispatch('getReportAttendance', params)
        this.analytics = result
        this.totalData = result.total
        return result.records
      },
      async paginatePage(page = 1, itemPerPage = 10) {
        this.page = page;
        this.itemPerPage = itemPerPage;
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
          .searchGroups, this.selectType, totalPageSend, start, this.partial, this.userId)
        this.attendances = [].concat(this.tempAttendances)
        if (this.search.length > 0) {
          this.calculateFilteredSummary(this.attendances, this.selectedUser)
        } else {
          this.calculateGeneralSummary(this.attendances)
        }
      },
      getDataForAdmin(companyId, startDate, endDate, groupId, shifted, totalPageSend, start, isPartial, userId) {
        this.destroyer.cancel('Canceled')
        return new Promise(async (resolve) => {
          setTimeout(() => {
            this.loading = true
          }, 100);
          this.destroyer = axios.CancelToken.source()
          const result = await Promise.all([
            this.getDataAttendanceAdmin(companyId, startDate, endDate, groupId, shifted, totalPageSend, start,
              isPartial, userId),
          ])
          this.loading = false
          return resolve(this.mappingAttendance(result))
        })
      },
      mappingAttendance(data = []) {
        let result = []
        data.map(item => {
          result = result.concat(item)
        })
        return _.orderBy(result, item => {
          return moment(item.date, 'YYYY-MM-DD')
        }, 'desc')
      },
      calculateGeneralSummary(data = []) {
        this.resetSummary()
        data.map(item => {
          this.countTimeSummary(item.reason_in)
          // this.countTimeSummary(item.reason_out)
          this.countLocationSummary(item.note_in)
          // this.countLocationSummary(item.note_out)
        })
      },
      async calculateFilteredSummary(user) {
        if (user) {
          this.userId = user.id;
        } else {
          this.userId = null;
        }
        this.page = 1;
        this.itemPerPage = 10;
        this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
          .searchGroups, this.selectType, this.itemPerPage, this.page, this.partial, this.userId)
        this.attendances = [].concat(this.tempAttendances)
        this.sumData(this.analytics)
        //   this.selectedUser = user
        //   this.search = user.full_name
        //   this.resetSummary()
        //   data.map(item => {
        //     if (item.userId == user.id) {
        //       this.countTimeSummary(item.reason_in)
        //       this.countTimeSummary(item.reason_out)
        //       this.countLocationSummary(item.note_in)
        //       this.countLocationSummary(item.note_out)
        //     }
        //   })
        // } else {
        //   this.search = ''
        //   this.calculateGeneralSummary(data)

      },
      checkRole() {
        this.role = this.$store.state.role
        switch (parseInt(this.role)) {
          case 0:
          case 2:
          case 4:
            this.listGroupByHierarchy()
            break
          case 3:
          default:
            this.searchGroups = this.groupId
            this.listGroupByHierarchySupervisor()
            break
        }
      },
      mappingGroupChildren(groups) {
        let result = []
        if (groups) {
          for (let i = 0; i < groups.length; i++) {
            if (groups[i])
              if (groups[i].children)
                if (groups[i].children.length > 0) {
                  result.push(groups[i])
                  result = result.concat(this.mappingGroupChildren(groups[i].children))
                } else {
                  result.push(groups[i])
                }
          }
        }
        return result.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      },
      async listGroupByHierarchy() {
        const result = await this.$store.dispatch('getGroupByHierarchyByCompany', {
          companyId: this.companyId
        })
        if (result.length > 0) {
          this.groupList = result
          this.groupListDownload = this.mappingGroupChildren(result)
          this.groupListDownload.unshift({
            id: null,
            name: this.$i18n.t('all')
          })
          this.userList = this.tempUserList
           this.userList.unshift({
            id: null,
            full_name: this.$i18n.t('all')
          })
        } else {
          this.groupList = []
          this.groupListDownload = []
        }
      },
      async listGroupByHierarchySupervisor() {
        const result = await this.$store.dispatch('getGroupListById', {
          id: this.groupId
        })
        if (result.length > 0) {
          this.groupList = result
          this.groupListDownload = result
          const groupId = this.groupListDownload.find(e => e.id == this.groupId)
          this.downloadMonthlyData.groupId = groupId ? groupId.id : ''
          this.filterUserByRole()
        } else {
          this.groupList = []
          this.groupListDownload = []
        }
      },
      getUserList() {
        return new Promise(async resolve => {
          this.tempUserList = []
          const result = await this.$store.dispatch('getEmployeeListNoPagination', {
            companyId: this.companyId
          })
          result.rows.map(user => {
            if (user.status) this.tempUserList.push(user)
          })
          setTimeout(() => {
            resolve(true)
          }, 500);
        })
      },
      async getUserListByGroupId(groupId) {
        this.userId2 = null
        this.loadingUser = true
        const result = await this.$store.dispatch('getEmployeeListByGroup', {
          groupId,
          mobile: 0
        })
        if (result) {
          this.loadingUser = false
          this.filteredUser = result.team_member
          this.filteredUser.unshift({
            id: null,
            fullname: this.$i18n.t('all')
          })
        }
        this.loadingUser = false
      },
      UserByRole() {
        const userList = []
        const groupList = this.groupList.map(item => {
          return parseInt(item.id)
        })
        this.tempUserList.map(user => {
          if (groupList.indexOf(user.groupId) > -1) userList.push(user)
        })
        this.userList = userList
      },
      closeTreeView() {
        this.toggleDropdown(false)
      },
      sumData(data) {
        const sum = this.analyticsSummary
        sum.on_time = data.on_time
        sum.tolerance_time = data.in_tolerance_time
        sum.late =
          data.late_incident +
          data.late_meeting +
          data.late_others
        sum.correction_time = data.correction_time
        sum.on_location = data.in_location
        sum.tolerance_location = data.in_tolerance_location_meeting + data.in_tolerance_location_wfh
        sum.out_of_location = data.out_tolerance_location
        sum.correction_location = data.correction_location

      },
      translateMe(word) {
        const translate = word.toLowerCase()
        return this.$i18n.t(translate)
      },
      async getGroupUsers() {
        const url = `${this.baseUrl}/user/listbygrouparray`
        try {
          const body = {
            groupsId: this.selectedGroups
          }
          const result = await axios.post(url, body, {
            headers: {
              action: 'Get User By Group Ids',
              actionId: 4
            }
          })
          if (result) {
            return result.data.data
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
        }
      },

    },
    async created() {
      this.destroyer = axios.CancelToken.source()
      this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      this.startDate2 = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.endDate2 = moment().format('YYYY-MM-DD')
      this.yearList = this.generateYearList()
      this.getGlobalConfig()
      await this.getUserList()
      this.checkRole()
      this.currentDate = this.startDate
      this.currentDate2 = this.startDate2
      this.getLimitDate(this.startDate)
      this.getLimitDate2(this.startDate2)
      this.tempAttendances = await this.getDataForAdmin(this.companyId, this.startDate, this.endDate, this
        .searchGroups, this.selectType, this.itemPerPage, this.page, this.partial, this.userId)
      // this.analytics = this.tempAttendances
      this.sumData(this.analytics)
      this.attendances = [].concat(this.tempAttendances)
      this.getCalendarHoliday()
      this.calculateGeneralSummary(this.attendances)
    },
    watch: {
      async selectedGroups() {
        if (!this.stillRunning) {
          this.stillRunning = true
          this.chooseSearch()
          this.checkStillRunning()
          this.findUserButton = true
          if (this.selectedGroups.length > 0) {
            this.userList = await this.getGroupUsers()
            this.findUserButton = false
          } else {
            if (this.role == 3) {
              this.filterUserByRole()
              this.findUserButton = false
            } else {
              this.userList = this.tempUserList
              this.findUserButton = false
            }
          }
        }
      }
    },

    components: {
      AnimateNumber
    },
    computed: {

    }
  };
</script>
<style>
  .set-radio1::before {
    content: 'Set Time';
    position: absolute;
    bottom: 55px;
    left: 10px;
    height: 10px;
  }

  .set-radio2::before {
    content: 'Pilih Waktu';
    position: absolute;
    bottom: 55px;
    left: 10px;
    height: 10px;
  }


  .f-13 {
    font-size: 13px;
  }

  .sae-dropdown {
    position: absolute;
    z-index: 2000;
  }

  @media only screen and (min-width: 1023px) {
    .sae-dropdown {
      width: 50%;
    }
  }

  .sae-hover {
    cursor: pointer;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

  .cursor {
    cursor: pointer;
  }

  .text-primary {
    color: #033a6d !important;
  }

  .spin {
    animation: spin 2s linear infinite;
  }

  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(-360deg);
    }
  }

  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(-360deg);
    }
  }

  @keyframes spin {
    100% {
      -webkit-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }
</style>